// extracted by mini-css-extract-plugin
export default {"accountGroup":"o_Mpy","accountGroupHeading":"efzQH","accountGroupTitle":"h61xL","accountGroupBalance":"fSHUL"};